import { RootState } from '../store'

export const selectIsRefreshBalance = (state: RootState) => state.rush.isRefreshBalance
export const selectIsRefreshBackpackValues = (state: RootState) =>
  state.rush.isRefreshBackpackValues

export const selectGemBalance = (state: RootState) => state.rush.gemBalance
export const selectBackpackValues = (state: RootState) => state.rush.backpackValues
export const selectIsOpenRushSkinsModal = (state: RootState) => state.rush.isOpenRushSkinsModal
